import React, { useState, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Loader from '../core/ui/loadingScreen/loadingScreen';
import { unacceptedAgreements } from '../common/services/http/agreementService';
import { canImpersonate, getUserSettings, verifyUser } from '../common/services/http/userService';
import { useIdentityManager } from '../common/hooks/useIdentityManager';
import { CAN_IMPERSONATE, SET_NAME, SET_TOOLTIP } from '../redux/types';
import routerConfig from './routerConfig';

import './routes.scss';

import FilterContext from '../context/filterContext/filterContext';
import DocsContext from '../context/docsContext/docsContext';

const Router = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [showAgreement, setShowAgreement] = useState(false);
  const [agreement, setAgreement] = useState(null);
  const identity = useIdentityManager();

  useEffect(() => {
    identity
      .isAuthenticated()
      .then((isAuthn: boolean | ((prevState: boolean) => boolean)) => {
        setAuthenticated(isAuthn);
        if (isAuthn) {
          return verifyUser().then((user) => {
            let authz = user !== null;
            setAuthorized(authz);
            if (authz) {
              dispatch({ type: SET_NAME, name: user.name });
              return unacceptedAgreements().then((r) => {
                if (r.data.length >= 1) {
                  setAgreement(r.data);
                  setShowAgreement(true);
                }
                canImpersonate()
                  .then((r) => {
                    dispatch({ type: CAN_IMPERSONATE, value: r });
                  })
                  .catch((e) => null);
                setLoading(false);
              });
            } else {
              setLoading(false);
              return Promise.resolve();
            }
          });
        } else {
          setLoading(false);
          return Promise.resolve();
        }
      })
      .catch((err: any) => {
        setLoading(false);
        console.error('error loading', err);
      });
  }, []);

  let element = useRoutes(routerConfig(setAuthorized, setAuthenticated, setShowAgreement, authorized, authenticated, showAgreement));

  if (loading) {
    return <Loader />;
  }

  return (
    <FilterContext>
      <DocsContext>
        {element}
      </DocsContext>
    </FilterContext>
  );
};

export default Router;
